import React, { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useT } from '../../i18n/I18nContext';
import './Header.css';

const Header = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const { t, lang, setLang } = useT();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleLang = () => {
    setLang(lang === 'en' ? 'zh-CN' : 'en');
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-shell">
          <NavLink to="/" className="brand-mark">
            <span className="brand-mark-icon">⚡</span>
            <span className="brand-mark-copy">
              <strong>{t('header.brand')}</strong>
              <small>{t('header.tagline')}</small>
            </span>
          </NavLink>

          <nav className="main-nav" aria-label="Primary navigation">
            <NavLink to="/" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`} end>
              {t('header.home')}
            </NavLink>
            {isAuthenticated && (
              <>
                <NavLink to="/dashboard" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
                  {t('header.dashboard')}
                </NavLink>
                <NavLink to="/settings" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
                  {t('header.settings')}
                </NavLink>
              </>
            )}
          </nav>

          <div className="header-actions">
            <button className="btn btn-secondary header-action-btn lang-toggle" onClick={toggleLang} title="Switch language">
              {lang === 'en' ? t('lang.zhCN') : t('lang.en')}
            </button>
            {isAuthenticated ? (
              <>
                <div className="user-chip">
                  <span className="user-chip-label">{t('header.signedInAs')}</span>
                  <strong>{user?.email}</strong>
                </div>
                <button className="btn btn-secondary header-action-btn" onClick={handleLogout}>
                  {t('header.logout')}
                </button>
              </>
            ) : (
              <>
                <NavLink to="/login" className="btn btn-secondary header-action-btn">
                  {t('header.login')}
                </NavLink>
                <NavLink to="/register" className="btn btn-primary header-action-btn">
                  {t('header.getStarted')}
                </NavLink>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
